import React from "react";

function Footer() {
    return (
        <footer id="footer">
            <p className="copyright">
                <strong>
                    &copy; Reliance Litigation, LLC. All rights reserved.
                </strong>
            </p>
            <p className="copyright">
                21550 Oxnard St, FL 3 • Woodland Hills, CA 91367 • (888)
                856-7299
            </p>
            <p className="copyright">
                {" "}
                <a
                    href="https://www.reliancelitigation.com/"
                    target="_blank"
                    title="Reliance Litigation"
                    rel="noopener noreferrer"
                >
                    <strong>RelianceLitigation.com</strong>
                </a>{" "}
                • <a href="/terms">Terms and Conditions</a> •{" "}
                <a href="/privacy">Privacy Policy</a> •{" "}
                <a href="/cookie">Cookie Policy</a>{" "}
            </p>
        </footer>
    );
}

export default Footer;
